import { Drawer, Dropdown, List, message } from "antd";
import clsx from "clsx";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
import ReactComponents from "react-antd-styled-components2";
import { FcBusinessman } from "react-icons/fc";
import {
  MdAccountCircle,
  MdBusiness,
  MdEmail,
  MdLogout,
  MdMoreVert,
  MdPerson,
  MdPhone,
  MdSettings,
} from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { customerMasters } from "../../config/Services/Userservices";
import { useThemeContext } from "../../context/AppContextProvider/ThemeContextProvider";
import { AuthContext } from "../../context/AuthContextProvider";
import { setCurrentCompany } from "../../redux/slices/companiesSlice";

const UserInfo = ({ hasColor, token }) => {
  const { User } = ReactComponents("CRM");
  const { StyledCrUserInfo } = User.Styles;

  const { themeMode } = useThemeContext();
  const { logout } = useContext(AuthContext);

  // Get companies data from Redux store
  // eslint-disable-next-line no-unused-vars
  const { allCompanies = [], currentCompany = {} } = useSelector(
    (state) => state.companies
  );
  const dispatch = useDispatch();
  const email = localStorage.getItem("email") || "";
  const mobile = localStorage.getItem("mobile") || "";
  const role = localStorage.getItem("role") || "";
  const companies = JSON.parse(localStorage.getItem("companies") || "[]");
  const customerCode = localStorage.getItem("bpCode") || null;

  const [isUserDrawerVisible, setIsUserDrawerVisible] = useState(false);
  const [userName, setUserName] = useState("");
  const [bpCode, setBpCode] = useState("");
  const [bpName, setBpName] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [userData, setUserData] = useState({
    email: email,
    phone: mobile,
    role: role,
    lastLogin: "2023-06-15 14:30:22",
  });

  // Function to handle company selection
  const handleCompanySelect = (company) => {
    // Only proceed if selecting a different company
    if (company.bpCode === customerCode) return;

    // Update Redux store
    dispatch(setCurrentCompany(company));

    // Update localStorage with selected company details
    const updatedUserData = {
      bpCode: company.bpCode,
      bpName: company.bpName,
      contractType: company.contractType,
      email: localStorage.getItem("email") || "",
      lineOfBusiness: company.lineOfBusiness,
      location: company.location,
      mobile: localStorage.getItem("mobile") || "",
      role: localStorage.getItem("role") || "",
      token: localStorage.getItem("token") || "",
      userName: localStorage.getItem("userName") || "",
      accountGroup: company.accountGroup || "", // Add this line to update accountGroup
      blacklisted: company.blacklisted ? "true" : "false",
    };

    // Save all updated values to localStorage
    Object.entries(updatedUserData).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });

    // Update state to reflect changes immediately
    setUserName(updatedUserData.userName);
    setBpCode(updatedUserData.bpCode);
    setBpName(updatedUserData.bpName);

    message.success(`Switched to ${company.bpName}`);
    window.location.replace(window.location.pathname); // This will re-mount the route
  };

  const fetchCustomerData = () => {
    const bpCode = localStorage.getItem("bpCode");
    const role = localStorage.getItem("role");

    if (!bpCode || !role) {
      message.error("bpCode or role not found.");
      return;
    }

    const requestPayload = {
      Request_Data: {
        bp_code: bpCode,
        role: role,
      },
    };

    customerMasters(requestPayload)
      .then((response) => {
        if (response?.data?.CUSTOMERS_BP?.CUSTOMERS_BPType) {
          const customerData = response.data.CUSTOMERS_BP.CUSTOMERS_BPType;
          setBpCode(customerData.CustomerNo);
          setBpName(customerData.CustomerName);
        }
      })
      .catch((error) => {
        console.error("Error fetching customer data:", error);
        message.error("Error fetching customer data.");
      });
  };

  useEffect(() => {
    const storedUserName = localStorage.getItem("bpName");
    setUserName(storedUserName || "User");
    setUserName(storedUserName || "User");
    fetchCustomerData();
  }, []);

  const items = [
    {
      key: 2,
      icon: <MdAccountCircle style={{ fontSize: "18px" }} />,
      label: (
        <div
          className="dropdown-item"
          style={{ fontWeight: "bold", fontSize: 12 }}
        >
          {localStorage.getItem("bpCode")}
        </div>
      ), // Display the retrieved username here
    },
    {
      key: 1,
      icon: <MdLogout style={{ fontSize: "18px" }} />,
      label: (
        <div
          className="dropdown-item"
          onClick={() => {
            logout();
            window.location.reload();
          }}
          style={{ fontSize: 12 }}
        >
          Logout
        </div>
      ),
    },
    {
      key: 2,
      icon: <MdPerson style={{ fontSize: "18px" }} />,
      label: <div className="dropdown-item">{userName}</div>,
    },
  ];

  const handleUserCardClick = () => {
    setIsUserDrawerVisible(true);
  };

  const handleDrawerClose = () => {
    setIsUserDrawerVisible(false);
  };

  // Function to render all companies with current one highlighted
  const renderAllCompanies = () => {
    return (
      <List
        size="small"
        dataSource={companies}
        renderItem={(company) => (
          <List.Item
            style={{
              padding: "12px",
              marginBottom: "8px",
              borderRadius: "6px",
              background: company?.bpCode === customerCode ? "#f6ffed" : "#fff",
              border:
                company?.bpCode === customerCode
                  ? "1px solid #b7eb8f"
                  : "1px solid #f0f0f0",
              cursor: "pointer",
              transition: "all 0.3s",
              ":hover": {
                background:
                  company?.bpCode === customerCode ? "#f6ffed" : "#f5f5f5",
              },
            }}
            onClick={() => handleCompanySelect(company)}
          >
            <div style={{ width: "100%" }}>
              <div
                style={{
                  fontWeight: "500",
                  color: company.bpCode === customerCode ? "#389e0d" : "#333",
                }}
              >
                {company.bpName}
                {company.bpCode === customerCode && (
                  <span
                    style={{
                      marginLeft: "8px",
                      color: "#389e0d",
                      fontSize: "12px",
                    }}
                  >
                    (Current)
                  </span>
                )}
              </div>
              <div
                style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}
              >
                <div>Code: {company.bpCode}</div>
                <div>Location: {company.location}</div>
                <div>LOB: {company.lineOfBusiness}</div>
                <div>Contract: {company.contractType}</div>
                <div>Account Group: {company.accountGroup}</div> {/* Add this line */}

              </div>
            </div>
          </List.Item>
        )}
      />
    );
  };

  return (
    <>
      <StyledCrUserInfo
        className={clsx("cr-user-info", {
          light: themeMode === "light",
        })}
      >
        <Dropdown.Button
          menu={{ items }}
          icon={<MdMoreVert size={20} />}
          trigger={["click"]}
          placement="bottomRight"
          size="large"
          overlayStyle={{ zIndex: 1052, minWidth: 150 }}
          onClick={handleUserCardClick}
        >
          {/* <div
            onClick={handleUserCardClick}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              cursor: "pointer",
            }}
          > */}
          <FcBusinessman size={25} />
          <b style={{ fontSize: 12 }}>
            {userName} - {bpCode}{" "}
          </b>
          {/* </div> */}
        </Dropdown.Button>
      </StyledCrUserInfo>

      {/* User Profile Drawer with Complete Company List */}
      <Drawer
        title="User Profile"
        placement="right"
        closable={true}
        onClose={handleDrawerClose}
        visible={isUserDrawerVisible}
        width={350}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src="/assets/images/bizman2.png"
            alt="User"
            style={{
              width: "70px",
              height: "70px",
              //borderRadius: "50%",
              marginBottom: "20px",
              //border: "2px solid #dc2925",
            }}
          />
          <h5 style={{ marginBottom: "5px" }}>{userName}</h5>
          <p style={{ color: "#666", marginBottom: "20px", fontSize: 12 }}>
            {bpName} - {bpCode}
          </p>

          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <MdEmail
                style={{
                  fontSize: "20px",
                  marginRight: "10px",
                  color: "#dc2925",
                }}
              />
              <span>{userData.email}</span>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <MdPhone
                style={{
                  fontSize: "20px",
                  marginRight: "10px",
                  color: "#dc2925",
                }}
              />
              <span>{userData.phone}</span>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <MdPerson
                style={{
                  fontSize: "20px",
                  marginRight: "10px",
                  color: "#dc2925",
                }}
              />
              <span>Role: {userData.role}</span>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <MdSettings
                style={{
                  fontSize: "20px",
                  marginRight: "10px",
                  color: "#dc2925",
                }}
              />
              <span>Last Login: {userData.lastLogin}</span>
            </div>

            {/* All Companies List */}
            <div style={{ margin: "20px 0" }}>
              <h5
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <MdBusiness style={{ marginRight: "8px", color: "#dc2925" }} />
                Companies :
              </h5>
              {companies.length > 0 ? (
                renderAllCompanies()
              ) : (
                <div
                  style={{
                    padding: "16px",
                    textAlign: "center",
                    color: "#999",
                  }}
                >
                  No companies available
                </div>
              )}
            </div>
          </div>

          <div style={{ marginTop: "30px", width: "100%", color: "#fff" }}>
            <button
              style={{
                width: "100%",
                padding: "10px",
                background: "#dc2925",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => {
                logout();
                window.location.reload();
              }}
            >
              <MdLogout style={{ marginRight: "8px" }} />
              Logout
            </button>
          </div>
        </div>
      </Drawer>

      <style jsx>{`
        .dropdown-item {
          transition: color 0.3s ease;
        }

        .dropdown-item:hover {
          color: #ff0000;
        }
      `}</style>
    </>
  );
};

export default UserInfo;

UserInfo.propTypes = {
  hasColor: PropTypes.bool,
};
